<template>
  <div class="onlie-shop">
    <div class="shop-main">
      <div class="head">
        <img
          class="icon-close"
          src="@/assets/close.png"
          @click="handlerClose()"
        />
      </div>
      <div
        class="main"
        :style="{ backgroundImage: `url(${imgList[lang]})` }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "onlie-shop",
  data() {
    return {
      imgList: {
        zh: require("../../../assets/420-shop-zh.svg"),
        en: require("../../../assets/420-shop-en.svg")
      },
      lang: "zh"
    };
  },
  props: {
    onlineShop: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "$i18n.locale": {
      handler(val) {
        this.lang = val;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    tabList() {
      return [
        {
          label: this.$t("Analysis of Online"),
          icon: require("@/assets/icon-doctor.png"),
          children: [
            this.$t("Pump seizure"),
            this.$t("Motor loads"),
            this.$t("Pump Noises")
          ]
        },
        {
          label: this.$t("Maintenance Service"),
          icon: require("@/assets/icon-repair.png"),
          children: [this.$t("Level-1"), this.$t("Level-2")]
        },
        {
          label: this.$t("Parts Purchase"),
          icon: require("@/assets/icon-cogs.png"),
          children: [this.$t("Select Part No")]
        }
      ];
    }
  },
  methods: {
    handlerClose() {
      this.$emit("update:onlineShop", false);
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.onlie-shop {
  width: 100%;
  height: 100%;
  background: #022037;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999999;
  .shop-main {
    width: 100%;
    height: 100%;
    background: url("../../../assets/onlineShop-bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-flow: column;
    padding: 0 40px;
    .head {
      position: absolute;
      top: 0.1rem;
      right: 0.1rem;
      .icon-close {
        width: 20px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .main {
      flex: 1;
      margin: 60px 30px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
